import { Dialog } from "primereact/dialog";
import React, { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { Button } from "primereact/button";
import { useForm } from "../../../../Base/Hooks/useForm";
import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";
import Loader from "../../../../Base/Components/Loader/Loader";
import { Toast } from "primereact/toast";
import { InputMask } from "primereact/inputmask";
import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { getTypesCategoria } from "../../../../Base/API/Global/Types/TypeRequest";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { getTasaCambio } from "../../../../API/CalendarioOperativo/CalendarioOperativoRequest";
import { toastShow } from "../../../../Base/Services/ToastService";
import { EditarRango, getUltimoRangoPorTipo, GuardarRango } from "../../../../API/Finanzas/RegistroContable/RangosDocumentosRequest";

const RangosCRUD = ({
  showDialog,
  selected,
  setSelected,
  setShowDialog,
  getInfo,
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const esAdmin = userAuth?.IdRol === 1;

  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [types, setTypes] = useState([]);
  const [dialogTitle, setDialogTitle] = useState("");
  const [tasaCambio, setTasaCambio] = useState([]);

  const initialValues = {
    IdRangoBoleto: -1,
    Prefijo: "",
    CAI: "",
    // RangoInicial: "",
    // RangoFinal: "",
    FechaEmision: new Date(),
    FechaVencido: new Date(),
    IdStatus: selected?.IdStatus ? selected?.IdStatus : 84,
    StatusName: selected?.StatusName ? selected?.StatusName : "Activo",
    Count: "",
    Comentarios: "",
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    const estadosTempo = await getEstadosCategory("RangoDocumentos");
    const typesTempo = await getTypesCategoria("Documentos Fiscales");
    const tasaTmepo = await getTasaCambio();
    setTasaCambio(tasaTmepo[0]?.TasaCambio);

    let estadoInicial;
    let typeInicial;
    if (selected?.IdRango) {
      setDialogTitle("Editar Rango");
      estadoInicial = estadosTempo.find((e) => e.IdStatus === selected?.IdStatus);
      typeInicial = typesTempo.find((e) => e.IdType === selected?.IdTipoRango);
    } else {
      setDialogTitle("Agregar Rango");
      estadoInicial = estadosTempo[0];
      typeInicial = typesTempo[0];
    }
    setEstados(estadosTempo);
    setTypes(typesTempo);

    setValues({
      ...selected,
      IdStatus: estadoInicial?.IdStatus,
      StatusName: estadoInicial,
      FechaEmision: selected?.FechaEmision? new Date(selected?.FechaEmision): null,
      FechaVencido: selected?.FechaVencido? new Date(selected?.FechaVencido): null,
      TasaCambio: selected ? selected?.TasaCambio : tasaTmepo[0]?.TasaCambio,
    });
    setLoading(false);
  };

  const verificarInfo = () => {
    let error = {};

    let IdTipoRango = values?.Type?.IdType || values?.IdTipoRango

    if(IdTipoRango === 49){
      if (!values?.NoExoneracion) {
        error.NoExoneracion = true;
        error.error = true;
      }
    }else{
      if (!values?.Prefijo) {
        error.Prefijo = true;
        error.error = true;
      }
      if (!values?.CAI) {
        error.CAI = true;
        error.error = true;
      }
      if (!values.Type?.IdType && !values?.IdTipoRango) {
        error.IdTipoRango = true;
        error.error = true;
      }
      if (!values?.RangoInicial) {
        error.RangoInicial = true;
        error.error = true;
      }
      if (!values?.RangoFinal) {
        error.RangoFinal = true;
        error.error = true;
      }
      if (!values?.Comentarios) {
        error.Comentarios = true;
        error.error = true;
      }
      if (!values?.TasaCambio) {
        error.TasaCambio = true;
        error.error = true;
      }
      // if (!values.StatusName?.IdStatus && !values?.IdStatus) {
      //   error.IdStatus = true;
      //   error.error = true;
      // }
    }

    if (!values?.FechaEmision) {
      error.FechaEmision = true;
      error.error = true;
    }
    if (!values?.FechaVencido) {
      error.FechaVencido = true;
      error.error = true;
    }

    setError(error);
    return error;
  };

  const agregarInformacion = async () => {
    const e = verificarInfo();
    if (e.error) {
      toastShow(toast,"warn","Advertencia","Completar los campos requeridos.");
      return;
    }

    if (parseInt(values?.RangoFinal) <= parseInt(values?.RangoInicial)) {
      toastShow(toast,"warn","Advertencia","Rango Final no puede ser menor o igual que Rango Inicial.");
      return;
    }

    if (!e?.error) {
      const Datos = {
        IdRango: values?.IdRango ? values?.IdRango : -100,
        IdTipoRango: values?.Type?.IdType || values?.IdTipoRango,
        Prefijo: values?.Prefijo,
        RangoInicial: parseInt(values?.RangoInicial),
        RangoFinal: parseInt(values?.RangoFinal),
        FechaEmision: new Date(values?.FechaEmision),
        FechaVencido: new Date(values?.FechaVencido),
        Comentarios: values?.Comentarios,
        CAI: values?.CAI,
        IdStatus: values?.StatusName?.IdStatus || values?.IdStatus,
        Count: values?.Count,
        TasaCambio: parseFloat(values?.TasaCambio),
        IdUserCreo: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
        NoExoneracion: values?.NoExoneracion,
      };

      setLoading(true);
      if (Datos?.IdRango > 0) {
        const respuesta = await EditarRango(Datos);
        if (respuesta[0].ESTADO !== -1) {
          toastShow(toast, "success", "Editado", respuesta[0].MENSAJE);
          setTimeout(() => {
            onHide();
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
          setLoading(false);
        }
      } else {
        const respuesta = await GuardarRango(Datos);
        if (respuesta[0].ESTADO !== -1) {
          toastShow(toast, "success", "Guardado", respuesta[0].MENSAJE);
          setTimeout(() => {
            onHide();
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
          setLoading(false);
        }
      }
    }
  };

  const handleInputChangeType = async (e) => {
    const { name, value } = e.target;
  
    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));

    if(!value){
      setValues((prev) => ({
        ...prev,
        RangoInicial: '',
        RangoFinal: '',
        Count: ''
      }));
    }
  
    if (value?.IdType) {
      const ultimosRango = await getUltimoRangoPorTipo(value.IdType);
  
      if (ultimosRango?.length > 0) {
        const rangoI = ultimosRango[0].RangoFinal + 1;
        const rangoF = (ultimosRango[0].RangoFinal - ultimosRango[0].RangoInicial) + rangoI;
        const contador = (ultimosRango[0].RangoFinal - ultimosRango[0].RangoInicial)
  
        setValues((prev) => ({
          ...prev,
          RangoInicial: rangoI,
          RangoFinal: rangoF,
          Count: contador
        }));
      } else {
        setValues((prev) => ({
          ...prev,
          RangoInicial: '',
          RangoFinal: '',
          Count: ''
        }));
      }
    }
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
    setSelected(null);
  };

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={"Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarInformacion}
        loading={loading}
      />
    </React.Fragment>
  );

  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        className="modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100%", margin: "auto" }}>
            <div className="d-flex align-items-center">
              <h4 className="mx-4">{dialogTitle}</h4>
            </div>
            <Toast ref={toast} />

            <div className="modal__input-contenedor">
              <div className="field col-3 me-2">
                  <span className="p-float-label">
                    <AutoCompleteDropdown
                      name={"Type"}
                      value={values?.Type}
                      items={types}
                      field={"Type"}
                      label={"Tipo Rango"}
                      handleInputChange={handleInputChangeType}
                      className={error.IdTipoRango ? "p-invalid" : ""}
                    />
                  </span>
              </div>

              <div className="field col-3 me-2">
                <span className="p-float-label">
                  <InputMask
                    id="basic"
                    mask="999-999-99"
                    name="Prefijo"
                    value={values?.Prefijo}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Prefijo ? "p-invalid" : ""}
                  />
                  <label htmlFor="Prefijo">Prefijo</label>
                </span>
              </div>

              <div className="field col-6 me-2">
                <span className="p-float-label">
                  <InputMask
                    id="basic"
                    mask="******-******-******-******-******-**"
                    name="CAI"
                    value={values?.CAI}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.CAI ? "p-invalid" : ""}
                  />
                  <label htmlFor="CAI">No. CAI</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-4 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    keyfilter="int"
                    name="RangoInicial"
                    value={values?.RangoInicial}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.RangoInicial ? "p-invalid" : ""}
                  />
                  <label htmlFor="RangoInicial">Rango Inicial</label>
                </span>
              </div>

              <div className="field col-4 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    keyfilter="int"
                    name="RangoFinal"
                    value={values?.RangoFinal}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.RangoFinal ? "p-invalid" : ""}
                  />
                  <label htmlFor="RangoFinal">Rango Final</label>
                </span>
              </div>

              <div className="field col-4 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Count"
                    disabled ={!esAdmin}
                    value={values?.Count}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Count ? "p-invalid" : ""}
                  />
                  <label htmlFor="Count">Cantidad</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-4 me-2 mt-2">
                <span className="p-float-label">
                  <Calendar
                    id="Fecha Emisión"
                    name="FechaEmision"
                    value={values?.FechaEmision}
                    onChange={(e) => handleInputChange(e, "FechaEmision")}
                    dateFormat="dd/mm/yy"
                    mask="99/99/9999"
                    yearRange="1900:2050"
                    monthNavigator
                    showButtonBar
                    yearNavigator
                    className={error.FechaEmision ? "p-invalid" : ""}
                    showIcon
                    style={{ width: "100%", height: 45 }}
                  />
                  <label htmlFor="FechaEmision">Fecha de Emisión</label>
                </span>
              </div>

              <div className="field col-4 me-2 mt-2">
                <span className="p-float-label">
                  <Calendar
                    id="FechaVencido"
                    name="FechaVencido"
                    value={values?.FechaVencido}
                    onChange={(e) => handleInputChange(e, "FechaVencido")}
                    dateFormat="dd/mm/yy"
                    mask="99/99/9999"
                    yearRange="1900:2050"
                    monthNavigator
                    showButtonBar
                    yearNavigator
                    className={error.FechaVencido ? "p-invalid" : ""}
                    showIcon
                    style={{ width: "100%", height: 45}}
                  />
                  <label htmlFor="FechaVencido">Fecha de Vencimiento</label>
                </span>
              </div>

              <div className="field col-4 me-2 mt-2">
                <span className="p-float-label">
                  <InputText
                    name="NoExoneracion"
                    value={values?.NoExoneracion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.NoExoneracion ? "p-invalid" : ""}
                  />
                  <label htmlFor="NoExoneracion">No. Exoneración</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-10 me-2 mt-2">
                <span className="p-float-label">
                  <InputTextarea
                    name="Comentarios"
                    value={values?.Comentarios}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Comentarios ? "p-invalid" : ""}
                  />
                  <label htmlFor="Comentarios">Comentario</label>
                </span>
              </div>

              <div className="field col-2 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    keyfilter="pnum"
                    name="TasaCambio"
                    value={values?.TasaCambio}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.TasaCambio ? "p-invalid" : ""}
                  />
                  <label htmlFor="TasaCambio">Tasa Cambio</label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default RangosCRUD;
